// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 777 ? "recorder" : chunkId) + "." + {"378":"222a07a4","453":"1018b9d0","777":"fceebb85","828":"01cef405"}[chunkId] + ".chunk.js";
};